import { Component, OnInit } from '@angular/core';
import { Kartable_Device_Point_Interface } from 'src/app/Interface/Kartable_Device_Point_Interface';
import { User_Interface } from 'src/app/Interface/User_Interface';
import { KartableService } from 'src/app/Service/Kartable/Kartable.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { UserService } from 'src/app/Service/User/User.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-KartableDevicePoint',
  templateUrl: './KartableDevicePoint.component.html',
  styleUrls: ['./KartableDevicePoint.component.scss']
})
export class KartableDevicePointComponent implements OnInit {

  Token:String=""
  Selected_User_Id:String="0"
  page=0

  Procssing:boolean=false



  constructor(
    private User_Service:UserService,
    private Nav_Service:NavService,
    private Kartable_Service:KartableService,
  ) { }


  DataList_Kartable:Array<Kartable_Device_Point_Interface>=[]
  DataList_Kartable_Option:Array<User_Interface>=[]

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.Nav_Service.CheckValidPage(this.Token,2176).subscribe(
      data=>{
        this.Read_User_Option()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  Read_User_Option(){
    this.Procssing=true
    this.User_Service.GetRecord(this.Token).subscribe(
      data=>{
        this.DataList_Kartable_Option=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  ReadData_User(StartSearchDate,EndSearchDate){
    this.Procssing=true
    this.Kartable_Service.GetDevicePoint(this.Token,StartSearchDate,EndSearchDate,this.Selected_User_Id).subscribe(
      data=>{
        this.DataList_Kartable=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  exportexcel(): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, "BehfaPoint.xlsx");

  }

}
